import { useEffect, useRef } from 'react';
import { useCrmOrgs } from '../components/pages/environments/useCrmOrgs';
import { useFeatureToggle } from '../feature-flags/useFeatureToggle';

export const useLoadOrgs = () => {
  const { hubspotAsOrg } = useFeatureToggle();
  const { getAllConnectedOrgs } = useCrmOrgs();
  const latestFetchId = useRef(0);

  // LD boots with an anonymous context, then useInitializeLdEffect identifies the real user — so
  // hubspotAsOrg can change after the first paint. useRunOnce would keep the wrong value forever
  // (HubSpot orgs filtered in Redux). Re-fetch when the flag changes. After hubspotAsOrg is removed,
  // switch back to useRunOnce(() => { void getAllConnectedOrgs(true); }) (or equivalent).
  //
  // Multiple in-flight /orgs requests can finish out of order; without a guard, an older response
  // (hubspotAsOrg false) can overwrite a newer one and drop HubSpot from the table.
  useEffect(() => {
    const includeHubspot = Boolean(hubspotAsOrg);
    const requestId = ++latestFetchId.current;
    void getAllConnectedOrgs(includeHubspot, {
      requestId,
      getLatestRequestId: () => latestFetchId.current,
    });
    return () => {
      latestFetchId.current += 1;
    };
  }, [getAllConnectedOrgs, hubspotAsOrg]);
};
